import * as React from 'react';
import { AssetPathContext } from '../context/AssetPathContext';
import { createAssetPath } from '../createAssetPath';
import { jsx as _jsx } from "react/jsx-runtime";
export function AssetPathContextProvider({
  assetEndpoint,
  manifestContent,
  assetPrefix = '',
  children
}) {
  const assetPath = React.useMemo(() => createAssetPath(assetEndpoint, manifestContent, assetPrefix), []);
  return /*#__PURE__*/_jsx(AssetPathContext.Provider, {
    value: assetPath,
    children: children
  });
}